//@flow
import * as React from 'react';
import { Box } from '@locus-taxy/neo-ui';
import HoveredCollapsibleList from './HoveredCollapsibleLists';
import { TerritoryContext } from './ManualTerritoryProvider';
import ItemCard from './ItemCard';
import { useTranslation } from 'react-i18next';

const TerritoryList = (): React.Node => {
    const {
        selectedTerritoryId,
        onTerritorySelect,
        hoveredTerritoryId,
        setHoveredTerritoryId,
        layerColorMap,
        territories,
        changeTerritoryName
    } = React.useContext(TerritoryContext);
    const { t } = useTranslation('entityManagement');
    const setHoveredEntity = React.useCallback(
        id => {
            setHoveredTerritoryId(id);
        },
        [setHoveredTerritoryId]
    );
    const renderItem = React.useCallback(
        itemProps => {
            const cardColor =
                selectedTerritoryId && selectedTerritoryId === itemProps.id
                    ? layerColorMap?.get(selectedTerritoryId)
                    : hoveredTerritoryId && hoveredTerritoryId === itemProps.id
                    ? layerColorMap?.get(hoveredTerritoryId)
                    : 'initial';
            return (
                <ItemCard
                    setHoveredEntity={setHoveredEntity}
                    cardColor={cardColor}
                    entity={itemProps}
                    isEditable={selectedTerritoryId === itemProps.id}
                    changeTerritoryName={changeTerritoryName}
                    selected={selectedTerritoryId === itemProps.id}
                    hovered={hoveredTerritoryId === itemProps.id}
                    onItemClick={onTerritorySelect}
                    subHeadingLabel={t('masterTerritoryProperties.id')}
                />
            );
        },
        [
            onTerritorySelect,
            selectedTerritoryId,
            hoveredTerritoryId,
            setHoveredEntity,
            layerColorMap,
            changeTerritoryName,
            t
        ]
    );
    const getKey = React.useCallback(({ id }) => id, []);

    return (
        <Box
            height="calc(100vh - 64px)"
            width={220}
            borderRight="1px solid"
            borderRightColor="grey.200"
        >
            <HoveredCollapsibleList
                title="Territories"
                list={territories}
                renderItem={renderItem}
                keyExtractor={getKey}
                onItemClick={onTerritorySelect}
            />
        </Box>
    );
};

export default React.memo(TerritoryList);
